import dayjs from 'dayjs';

import { useRouter } from '../../../util/hook/custom';
import useRef from '../../../util/hook/useRef';

import { S } from './style';

import { COMMON_ROUTES } from '../../../config/route';
import { REDIRECT_TO_CONFIG_PAGE } from '../../../config/ui/time';

export default function ConfigHeader() {
  const clickTimeList = useRef<string[]>([]);
  const { navigate } = useRouter();

  const onClickHandler = () => {
    // handle the behavior of redirecting the user to the config page
    clickTimeList.current = [...clickTimeList.current, dayjs().format()];
    if (clickTimeList.current.length < REDIRECT_TO_CONFIG_PAGE.CLICK_COUNT) return;
    // trigger the mechanism every [REDIRECT_TO_CONFIG_PAGE.CLICK_COUNT] times
    if (clickTimeList.current.length % REDIRECT_TO_CONFIG_PAGE.CLICK_COUNT > 0) return;

    const lastIndex = clickTimeList.current.length - 1;

    const timeFirst = dayjs(
      clickTimeList.current[lastIndex - (REDIRECT_TO_CONFIG_PAGE.CLICK_COUNT - 1)],
    );
    const timeLast = dayjs(clickTimeList.current[lastIndex]);
    const timeDiff = timeLast.diff(timeFirst, REDIRECT_TO_CONFIG_PAGE.DIFF_TIME_CONSTRAINT_UNIT);
    const isValid = timeDiff <= REDIRECT_TO_CONFIG_PAGE.DIFF_TIME_CONSTRAINT;

    if (isValid) {
      navigate(COMMON_ROUTES.CONFIG);
    }
  };

  return <S.Wrapper onClick={onClickHandler} />;
}
